import { render, staticRenderFns } from "./buy_jmhb.vue?vue&type=template&id=b60a1554&scoped=true"
import script from "./buy_jmhb.vue?vue&type=script&lang=js"
export * from "./buy_jmhb.vue?vue&type=script&lang=js"
import style0 from "./buy_jmhb.vue?vue&type=style&index=0&id=b60a1554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60a1554",
  null
  
)

export default component.exports